import React from 'react'
import { useBanner } from '../../../../reactQuery/banner';

function Banner() {
    const { isLoading, error, filename, isError, refetch } = useBanner();
  return (
    <div>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <img
          src={`${process.env.REACT_APP_BASE_URL}${filename}`}
          alt="banner"
          className="banner-image"
        />
      )}
    </div>
  );
}

export default Banner